export default class Note {
  static get toolbox() {
    return {
      title: "Quote",
      icon: `<i class="fad fa-quote-right"></i>`,
    };
  }

  constructor({ data, api }) {
    if (data && typeof data === "string") this.data = data;
  }

  render() {

    let wrapper = document.createElement("div");
    wrapper.classList.add("proEditorWrapper");
    let q1 = document.createElement("p");
    q1.classList.add("q1");
    q1.contentEditable = true;
    if (this.data) q1.innerHTML = this.data;

    wrapper.appendChild(q1);
    return wrapper;
  }

  save(blockContent) {
    let value = blockContent.querySelector('.q1').innerHTML;
    return value
  }

  static get sanitize() {
    return {
      a: true,
      i: true,
      b: true,
    };
  }
  
}